module.exports = __webpack_public_path__ + "img/btn-arrow-top-g.f7ecf4d3.svg";